const UrlTls = {
    getBaseUrl(){
        // return 'http://localhost/myapi';
return 'http://plan-api.lepton.ir';
    }
}
export { UrlTls };